module.exports = __webpack_public_path__ + "img/det-var-bare-for-sjov-1.cefbd2a1.png";